import { JSX } from 'react';
import { checkDatasourceForRendering } from 'src/shared/checkDatasourceForRendering';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { ReverseRows } from '@ahc-digital/component-library';
import { CreateReverseRowStoriesModel } from './C11ReverseRowStories.service';
import { C11ReverseRowStoriesProps } from './C11ReverseRowStories.types';

const Default = (props?: C11ReverseRowStoriesProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  return (
    <ReverseRows
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      data-component={marketingRenderingName}
      {...CreateReverseRowStoriesModel(props)}
    />
  );
};

export default checkDatasourceForRendering<C11ReverseRowStoriesProps>(Default);
